export function obterListaClassificacaoIBSZFM() {
  return (
    [
      { label: '', value: null },
      { label: '0 Sem Crédito Presumido', value: '0' },
      { label: '1 Bens de Consumo Final (55%)', value: '1' },
      { label: '2 Bens de Capital (75%)', value: '2' },
      { label: '3 Bens Intermediários (90,25%)', value: '3' },
      { label: '4 Bens de Informática e outros definidos em legislação (100%)', value: '4' },
    ]
  );
}
